import { WSService } from "../../../../utils/WSService";

export const cardsService = new WSService("/v2/banking/card");
